import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Paper } from '@mui/material';
import Titlebar from '../../TitleBar';
import { Pagination, SearchTable, TableHeader } from '../../TableTemplate/index';
import { TableBody } from '.';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import { applyFilter, emptyRows, getComparator, extractDate } from '../../../Utils/table';
import { jobworkMenu, StitchEntrylist } from '../../TitleList';
import axios from 'axios';


const FixedEmpJobworkReg = () => {
    const dispatch = useDispatch();
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('empId');
    const [selected, setSelected] = useState([]);
    const [filterName, setFilterName] = useState('null');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState(10);
    const [searchQuery, setSearchQuery] = useState("");
    const [firstIndex, setFirstIndex] = useState(0);
    const [lastIndex, setLastIndex] = useState(0);

    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [pageRange, setPageRange] = useState([0, 10]); // Initial range [0, 10]
    const [searchTerm, setSearchTerm] = useState('');

    const [jobworklist, setJobworklist] = useState([]);

    useEffect(() => {
        fetchFixedEmpJobworkApi();
    }, []);
    const searchFixedEmpJobworkApi = async (value) => {
    try {
        const res = await axios.get(`${baseUrl}`, {
            params: {
                apicall: "searchFixEmpReg",
                search: value
            }
        });
        console.log("search res=>",res.data);
        setJobworklist(res.data);
    } catch (error) {
        console.error(error);
    }
}
    const fetchFixedEmpJobworkApi = async () => {
        try {
            const res = await axios.get(`${baseUrl}?apicall=getFixedEmployeeJobworkReg`);
            const data = res?.data;
            setJobworklist(data);
        } catch (error) {
            console.error(error);
        }
    }

    // console.log(jobworklist);
    const compData = Array.isArray(jobworklist.data) ? jobworklist?.data?.map((item, index) => (
        {
            serialNumber: index + 1,
            srno: item.ID,
            entrydate: item.entrydate,
            fromdt: item.fromdt,
            todt: item.todt,
            empId: item.empId,
            empNm: item.empNm,
            work_type: item.work_type,
            work_hrs: item.work_hrs,
            totdays: item.totdays,
            present_days: item.present_days,
            leave_days: item.leave_days,
            leave_amt: item.leave_amt,
            perHr_amt: item.perHr_amt,
            perDay_amt: item.perDay_amt,
            amt: item.amt,
            dedamt: item.dedamt,
            totamt: item.totamt,
            extra_hrs: item.extra_hrs,
            extrahrs_amt: item.extrahrs_amt,
            narr: item.narr,
            sts: item.sts
        }
    )) : [];

    const handleSort = (event, id) => {
        const isAsc = orderBy === id && order === 'asc';
        if (id !== '') {
            setOrder(isAsc ? 'desc' : 'asc');
            setOrderBy(id);
        }
    };
    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = compData.map((n) => n.name);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, name) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1)
            );
        }
        setSelected(newSelected);
    };
    const handleChangeCPage = (n) => {
        setCurrentPage(n);
    };
    const handlePrevPage = () => {
        if (currentPage !== firstIndex) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextpage = () => {
        if (currentPage !== lastIndex) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handleRecordsPerPageChange = (event) => {
        setRecordsPerPage(parseInt(event.target.value, 10)); // Parse selected value to integer
        setCurrentPage(0); // Reset current page when records per page changes
    };

    const totalCount = compData.length;
    const npages = Math.ceil(totalCount / recordsPerPage);
    const numbers = Array.from({ length: npages }, (_, i) => i + 1);

    // const handleSearchChange = (event) => {
    //     setSearchTerm(event.target.value);
    //     setCurrentPage(1); // Reset to first page on search
    // };
    const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearchTerm(value);
    setCurrentPage(1);

    if (value.trim() === "") {
        fetchFixedEmpJobworkApi(); // load all data again
    } else {
        searchFixedEmpJobworkApi(value); // call search API
    }
};

    const filteredData = (Array.isArray(compData) ? compData : []).filter(item =>
        item?.entrydate?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item?.empNm?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const renderPaginationButtons = () => {
        let start = Math.max(0, currentPage - 10);
        let end = Math.min(npages, start + 9);

        if (end - start < 9) {
            start = Math.max(1, end - 9);
        }

        return numbers.slice(start - 1, end).map((n) => (

            <button key={n} className={`page-link ${currentPage === n ? 'active' : ''}`} onClick={() => handleChangeCPage(n)}>{n}</button>
        ));
    };

    const handleFilterByName = (event) => {
        setPage(0);
        let value = event.target.value.trim();
        setFilterName(event.target.value);
    };

    const dataFiltered = applyFilter({
        inputData: filteredData,
        comparator: getComparator(order, orderBy),
    });
    const totalPages = Math.ceil(filteredData.length / itemsPerPage);
    const displayedData = filteredData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);


    const pageNumbers = Array.from({ length: totalPages }, (_, index) => index + 1);
    const visiblePageNumbers = pageNumbers.slice(pageRange[0], pageRange[1]);

    const handleNextPageRange = () => {
        setPageRange([pageRange[0] + 5, pageRange[1] + 5]);
    };

    const handlePreviousPageRange = () => {
        setPageRange([pageRange[0] - 5, pageRange[1] - 5]);
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleItemsPerPageChange = (event) => {
        setItemsPerPage(Number(event.target.value));
        setCurrentPage(1); // Reset to first page on change
    };

    return (
        <>
            <Titlebar data={jobworkMenu} />

            <div style={{ margin: '1%' }}>
                <h2>Fixed Employee Jobwork Register</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '3vh', margin: '0' }}>

                            <SearchTable
                                handleItemsPerPageChange={handleItemsPerPageChange}
                                searchTerm={searchTerm}
                                handleSearchChange={handleSearchChange}
                                totalItems={filteredData?.length}
                            />

                            <TableContainer style={{ marginTop: '2%' }}>
                                <Table>
                                    <TableHeader
                                        headCells={
                                            [
                                                { id: 'srno', label: 'SrNo' },
                                                { id: 'dt', label: 'Entry Date' },
                                                { id: 'fromdt', label: 'From-To Date' },
                                                { id: 'empNm', label: 'Employee' },
                                                { id: 'work_type', label: 'Work Type' },
                                                { id: 'work_hrs', label: 'Work Hours' },
                                                { id: 'totdays', label: 'Total Days' },
                                                { id: 'present_days', label: 'Present Days' },
                                                { id: 'leave_days', label: 'Leave Days' },
                                                { id: 'leavt_amt', label: 'Leave Amt.' },
                                                { id: 'perHr_amt', label: 'Per Hour Amt.' },
                                                { id: 'perDay_amt', label: 'Per Day Amt.' },
                                                { id: 'extra_hrs', label: 'Extra Work Hours' },
                                                { id: 'extrahrs_amt', label: 'Extra Hours Amount' },
                                                { id: 'amt', label: 'Amount' },
                                                { id: 'dedamt', label: 'Deduct Amt.' },
                                                { id: 'totamt', label: 'Total Amt.' },
                                                { id: 'narr', label: 'Narration' },
                                                // { id: '', label: 'Payment Status' },
                                                { id: '', label: 'View' },
                                                { id: '', label: 'Delete' }
                                            ]
                                        }
                                        order={order}
                                        orderBy={orderBy}
                                        onRequestSort={handleSort}
                                        numSelected={selected.length}
                                        rowCount={compData.length}
                                        onSelectAllClick={handleSelectAllClick}
                                    />
                                    <tbody>
                                        {displayedData.map((row) => (
                                            <TableBody
                                                key={row.srno}
                                                id={row.srno}
                                                entrydate={row.entrydate}
                                                fromdt={row.fromdt}
                                                todt={row.todt}
                                                empId={row.empId}
                                                empNm={row.empNm}
                                                work_type={row.work_type}
                                                work_hrs={row.work_hrs}
                                                totdays={row.totdays}
                                                present_days={row.present_days}
                                                leave_days={row.leave_days}
                                                leave_amt={row.leave_amt}
                                                perHr_amt={row.perHr_amt}
                                                perDay_amt={row.perDay_amt}
                                                amt={row.amt}
                                                dedamt={row.dedamt}
                                                totamt={row.totamt}
                                                extrahrs_amt={row.extrahrs_amt}
                                                extra_hrs={row.extra_hrs}
                                                narr={row.narr}
                                                sts={row.sts}
                                                serialNumber={row.serialNumber}
                                                selected={selected.indexOf(row.name) !== -1}
                                                handleClick={(event) => handleClick(event, row.name)}
                                            />
                                        ))}
                                    </tbody>
                                </Table>
                            </TableContainer>

                            <Pagination
                                currentPage={currentPage}
                                handlePageChange={handlePageChange}
                                handlePreviousPageRange={handlePreviousPageRange}
                                visiblePageNumbers={visiblePageNumbers}
                                pageNumber={pageNumbers}
                                pageRange={pageRange}
                                totalPages={totalPages}
                                handleNextPageRange={handleNextPageRange}
                            />
                        </Paper>
                    </Grid>
                </Grid>
            </div>

        </>
    );
}

export default FixedEmpJobworkReg;
